import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Grid,
  FormControl,
  Select,
  IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import TextInputs from 'src/components/inputs/TextInputs';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useNavigate } from 'react-router';
import TimeSlotSelector from 'src/components/inputs/TimeSlotSelector';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { useDispatch , useSelector } from 'react-redux';
import { removeAppointmentsFromState } from 'src/redux/slices/appointmentSlice';
import { changeTimeFormate } from 'src/utils/dateutils';
import SelectInputs from 'src/components/inputs/SelectInputs';
import UpdateServiceslist from './UpdateServiceslist';
import { getHighlightedText } from 'src/utils/textUtils';


const initialValue = {
  clientName: '',
  clientNumber: '',
  dateOfAppointment: '',
  sourceOfAppointment: '',
  timeOfAppointment: '',
  gender: '',
   serviceSelected: [
    {
      service: '',
      serviceName: '',
      serviceProvider: '',
    },
  ],
};

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const Appointments = ({ data = [], getData }) => {
  const dispatch = useDispatch();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [updateData, setUpdateData] = useState(initialValue);
  const [selectedItemId, setSelectedItemId] = useState('');
  const [openDialogue, setOpenDialogue] = useState(false);
  const [services, setServices] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateMask, setUpdateMask] = useState(false);
  const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
  const [serviceSuggested, setServiceSuggested] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [dialogHeight, setDialogHeight] = useState('auto');
  const [branchTimings, setBranchTimings] = useState({salonOpeningTime: '', salonClosingTime: '',});
  const navigate = useNavigate();
  const { filters } = useSelector((state) => state.appointments);

  const {
    activeBranchId,
    getBranch,
    setShowMessage,
    updateAppointment,
    deleteAppointment,
    branchData,
    getBranchTimings,
  } = useMain();

  useEffect(() => {
    setUpdateMask(!updateMask);
  }, [branchData?.isMasked]);
 useEffect(() => {
  const fetchTimings = async () => {
    if (activeBranchId) {
      const res = await getBranchTimings(activeBranchId);
      if (res?.statusCode === 200 && res?.data) {
        setBranchTimings({
          salonOpeningTime: res.data.salonOpeningTime || '',
          salonClosingTime: res.data.salonClosingTime || '',
        });
      }
    }
  };
  fetchTimings();
  }, [activeBranchId]);

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
  };

 const handleUpdate = (item) => {
    setSelectedItemId(item._id);
    const {
      clientName,
      clientNumber,
      gender,
      serviceSelected,
      sourceOfAppointment,
      dateOfAppointment,
      timeOfAppointment,
    } = item;

    setUpdateData({
      clientName,
      clientNumber,
      dateOfAppointment,
      sourceOfAppointment,
      timeOfAppointment,
      gender,
      serviceSelected: serviceSelected?.map(({ service, serviceProvider, serviceName }) => ({
        service: service?._id || '',
        serviceProvider: serviceProvider?._id || '',
        serviceName: serviceName || service?.serviceName || '',
      })) || [{ service: '', serviceProvider: '', serviceName: '' }],
    });
    setOpenDialogue(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateData((pre) => ({ ...pre, [name]: value }));
  };

  const updateServiceSuggested = (inputValue) => {
    if (inputValue === '') {
      setServiceSuggested([]);
      setFocusedServiceIndex(null);
    } else {
      const serviceSuggestions = services?.filter((service) =>
        service.serviceName.toLowerCase().includes(inputValue.toLowerCase())
      );
      setServiceSuggested(serviceSuggestions);
    }
  };

  const handleServiceInputChange = (e, index) => {
    const { name, value } = e.target;
    if (name === 'service') {
      const updatedServiceSelected = [...updateData.serviceSelected];
      updatedServiceSelected[index]['service'] = '';
      updatedServiceSelected[index]['serviceName'] = value;
      setUpdateData((prev) => ({ ...prev, serviceSelected: updatedServiceSelected }));
      updateServiceSuggested(value);
      setFocusedServiceIndex(index);
    }
  };

    const handleServiceSelectedInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedServiceSelected = [...updateData.serviceSelected];
    updatedServiceSelected[index][name] = value;
    setUpdateData((prev) => ({ ...prev, serviceSelected: updatedServiceSelected }));
  };

  const handleServiceSuggestedClick = (service, index) => {
    const updatedServiceSelected = [...updateData.serviceSelected];
    updatedServiceSelected[index]['service'] = service?._id;
    updatedServiceSelected[index]['serviceName'] = service?.serviceName;
    setUpdateData((prev) => ({ ...prev, serviceSelected: updatedServiceSelected }));
    setServiceSuggested([]);
  };

  const addRow = () => {
    const isUnFillField = (updateData.serviceSelected || []).some(
      (item) => item.serviceProvider === '' || item.service === '',
    );
    if (isUnFillField)
      return setShowMessage({
        message: 'Please select a staff and services',
        messageType: 'error',
      });
    setUpdateData((pre) => ({
      ...pre,
      serviceSelected: [...(pre.serviceSelected || []), { service: '', serviceProvider: '' }],
    }));
  };

  const removeRow = (index) => {
    const updatedServiceSelected = [...(updateData.serviceSelected || [])];
    updatedServiceSelected.splice(index, 1);
    setUpdateData((pre) => ({ ...pre, serviceSelected: updatedServiceSelected }));
  };

  // const handleUpdateAppointmentData = async () => {
  //   const {
  //     clientName,
  //     gender,
  //     clientNumber,
  //     timeOfAppointment,
  //     dateOfAppointment,
  //     sourceOfAppointment,
  //   } = updateData;
  //   if (clientName.trim() === '')
  //     return setShowMessage({ message: 'Client Name is Required', messageType: 'error' });
  //   if (timeOfAppointment === '')
  //     return setShowMessage({ message: 'Time of Appointment is Required', messageType: 'error' });
  //   if (clientNumber === '')
  //     return setShowMessage({ message: 'Client Number is Required', messageType: 'error' });
  //   if (dateOfAppointment === '')
  //     return setShowMessage({ message: 'Appointment Date is Required', messageType: 'error' });
  //   if (sourceOfAppointment === '')
  //     return setShowMessage({ message: 'Source is Required', messageType: 'error' });
  //   if (gender === '')
  //     return setShowMessage({ message: 'Gender is Required', messageType: 'error' });
  //   const isUnFillField = updateData.serviceSelected.some(
  //     (item) => item.serviceProvider === '' || item.service === '',
  //   );
  //   if (isUnFillField)
  //     return setShowMessage({
  //       message: 'Please select a staff and services',
  //       messageType: 'error',
  //     });
  //   try {
  //     setLoading(true);
  //     const res = await updateAppointment(
  //       selectedItemId,
  //       updateData,
  //       `?branchId=${activeBranchId}`,
  //     );
  //     if (res.statusCode === 200) {
  //       setUpdateData((pre) => ({
  //         ...pre,
  //         ...initialValue,
  //         serviceSelected: [
  //           {
  //             service: '',
  //             serviceProvider: '',
  //           },
  //         ],
  //       }));
  //       getData();
  //       return setShowMessage({
  //         message: res?.message || 'Appointment updated successfully',
  //         messageType: 'success',
  //       });
  //     } else {
  //       return setShowMessage({
  //         message: res?.message || 'Error ouccures in update appointment',
  //         messageType: 'error',
  //       });
  //     }
  //   } catch (error) {
  //     setShowMessage({
  //       message: error?.message || 'Error ouccures in update appointment',
  //       messageType: 'error',
  //     });
  //   } finally {
  //     setLoading(false);
  //     setOpenDialogue(false);
  //   }
  // };


  const handleUpdateAppointmentData = async () => {
    try {
      setLoading(true);
      const res = await updateAppointment(selectedItemId, updateData, `?branchId=${activeBranchId}`);
      if (res.statusCode === 200) {
        getData()
        setShowMessage({
          message: res?.message || 'Appointment updated successfully',
          messageType: 'success',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error?.message || 'Error occurs in update appointment',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
      setOpenDialogue(false);
    }
  };


  const handleDeleteField = (id) => {
    setSelectedItemId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    try {
      setLoading(true);
      const res = await deleteAppointment(selectedItemId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        setShowMessage({ message: 'Appointment deleted successfully', messageType: 'success' });
        dispatch(removeAppointmentsFromState([selectedItemId]));
      }
    } catch (error) {
      setShowMessage({ message: error?.message || 'Error occurred while deleting appointment', messageType: 'error' });
    } finally {
      setOpenDeleteDialog(false);
      setLoading(false);
    }
  };



  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedItemId('');
  };

  const getAllData = async () => {
    try {
      const res = await getBranch(activeBranchId);
      setStaff(res?.data?.staffs || []);
      setServices(res?.data?.services || []);
    } catch (error) { }
  };

  useEffect(() => {
    if (activeBranchId) {
      getAllData();
    }
  }, [activeBranchId]);


  const handleDetails = (id) => {
    navigate(`/appointments-history/${id}`);
  };

  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      <table className="table-container mt-3">
        <thead className="table-thead">
          <tr>
            {[
              'Client Name',
              'Number',
              'Gender',
              'Date of Appointment',
              'Time of Appointment',
              'Appointment Status',
              'Source Of Appointment',
              // 'Notes',
              'Actions',
            ].map((h, index) => {
              return (
              <th key={index} style={{ minWidth: h === 'Client Name' ? '150px' : 'auto' , textAlign: 'center'}}>
                  {h}
                </th>
              );
            })}
          </tr>
        </thead>
       <tbody className="table-tbody">
          {data?.map((item) => {
            const originalDate = item?.dateOfAppointment;
            let formattedAppointmentDate = '';
            if (originalDate) {
              const [year, month, day] = originalDate.split('-');
              formattedAppointmentDate = `${day}-${month}-${year}`;
            }
            return (
              <tr key={item._id}>
                <td style={{ minWidth: '150px'  , textAlign: 'center'}}>{getHighlightedText(item?.clientName, filters?.search)}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>
                  {typeof branchData?.isMasked !== 'boolean' || !item?.clientNumber
                    ? 'loading...'
                    : getHighlightedText(maskData(item?.clientNumber, branchData?.isMasked), filters?.search)}
                </td>
                <td style={{ width: '10%', textAlign: 'center' }}>{item?.gender}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>{formattedAppointmentDate}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>{changeTimeFormate(item?.timeOfAppointment)}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>{item?.appointmentStatus}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>{item?.sourceOfAppointment}</td>

                <td
                  style={{
                    width: '200px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <IconButton
                    onClick={() => handleDetails(item._id)}
                    color="primary"
                    title="View Details"
                    style={{ margin: '-2px' }}
                  >
                    <AiOutlineInfoCircle
                      style={{ color: '#696969', fontSize: '1.1rem', marginLeft: '1.5rem' }}
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => handleUpdate(item)}
                    color="secondary"
                    title="Update"
                    style={{ margin: '-2px' }}
                  >
                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteField(item._id)}
                    color="error"
                    title="Delete"
                    style={{ margin: '-6px' }}
                  >
                    <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem', marginTop: '1px' }} />
                  </IconButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this appointment?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary" disabled={loading}>
            {/* {loading ? 'Deleting...' : 'Delete'} */}
            Delete
          </Button>
        </DialogActions>
      </Dialog>

       <Dialog
          open={openDialogue}
          onClose={handleCloseDialogue}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '80vh',
              overflow: 'visible',
              maxWidth:'600px'
            }
          }}
        >
        <DialogTitle>Appointment Details</DialogTitle>
        <DialogContent>
          <DialogContentText>Here you can update the appointment details.</DialogContentText>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Date of Appointment'}
                  name={'dateOfAppointment'}
                  value={updateData?.dateOfAppointment || ''}
                  handleChange={handleChange}
                  type={'date'}
                  min={new Date().toISOString().split('T')[0]}
                  required={false}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TimeSlotSelector
                      title={'Time of Appointment'}
                      name={'timeOfAppointment'}
                      value={updateData?.timeOfAppointment || ''}
                      handleChange={handleChange}
                      branchTimings={branchTimings}
                      isToday={
                        updateData?.dateOfAppointment
                          ? new Date().toDateString() === new Date(updateData.dateOfAppointment).toDateString()
                          : false
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {/* Service Rows with Custom Input Field */}
          {(updateData.serviceSelected || []).map((item, index) => (
            <Box key={index} style={{ marginTop: '20px' }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <label>
                    Services
                    {/* <IoStar
                      color="red"
                      style={{ height: '6px', fontWeight: 'bold', marginBottom: '10px' }}
                    /> */}
                  </label>
                  <input
                    type="text"
                    className={`form-control ${item?.serviceName === '' ? 'border border-2' : ''}`}
                    placeholder="Service"
                    name="service"
                    value={item?.serviceName}
                    onChange={(e) => handleServiceInputChange(e, index)}
                    autoComplete="off"
                    style={{
                      padding: '14px',
                      border: '1px solid #dee2e6',
                      outline: isFocused ? '2px solid #6174DD' : 'none',
                      width: '100%',
                      borderRadius: '4px',
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />

                  {serviceSuggested.length > 0 && focusedServiceIndex === index && (
                    <Box sx={{ mt: 1 }}>
                      <UpdateServiceslist
                        data={serviceSuggested}
                        handleServiceSuggestedClick={(service) =>
                          handleServiceSuggestedClick(service, index)
                        }
                      />
                    </Box>
                  )}

                </Grid>

                <Grid item xs={12} md={4}>
                  <SelectInputs
                    name={'serviceProvider'}
                    value={item?.serviceProvider}
                    title={'Assign to'}
                    handleChange={(e) => handleServiceSelectedInputChange(e, index)}
                    options={staff}
                    optionValue={'_id'}
                    optionTitle={'name'}
                    required={false}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200,
                          overflow: 'auto'
                        }
                      }
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '5px' }}
                >
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        background: '#6174DD',
                        width: '64px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                      }}
                      onClick={addRow}
                    >
                      Add
                    </Button>
                  </Grid>
                  {index !== 0 ? (
                    <Grid item xs={12} md={4}>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          background: '#ff0000',
                          width: '64px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          '&:hover': {
                            background: '#ff6666',
                          },
                        }}
                        onClick={() => removeRow(index)}
                      >
                        Remove
                      </Button>
                    </Grid>
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader value={loading} />
          ) : (
            <>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleUpdateAppointmentData}
                >
                  Update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Appointments;

function getCurrentDateInFormat(date) {
  const today = new Date(date);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
